import React from 'react'
import './laserCut.css'

import { buildLaserContext } from '../../../Utils/buildContext'
import laser from '../../../assets/laser.png'

function LaserCut({lang}) {
  const context = buildLaserContext(lang)

   const handleOnCLick = () =>{
    const el = document.getElementById("contact")
    if (el) {
      el.scrollIntoView({ behavior: "smooth" })
    }
  }

  return (
    <div id="laser-cut" className='laser-cut'>
      <div className="left">
        <h2>{context.title}</h2>
        <p>{context.text}</p>
      </div>

      <div className="right">
        <img src={laser} alt="laser" className="laser-img" />
        
        <div className="infos">
          <h2>{context.sub_title}</h2>
          <button onClick={handleOnCLick}>{context.button_text}</button>
        </div>
      </div>
    </div>
  )
}

export default LaserCut